export const avoidCharacters = ["|", "#", "<", "~", "[", ">", '"', "]", "`", "%", "}", "^", "{", "?", ",", "+", ":", ";", "=", "@", "$", "&"];